export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-queue/src/array.js
// module id = ../../../../d3-queue/src/array.js
// module chunks = 3